import PropTypes from 'prop-types';
import React from 'react';
import { lookerParams } from '../../../../../shared/lookerParams';
import OutputTab from '../OutputTab';

InputVariables.propTypes = {
    activeTab: PropTypes.string,
    onLoadComplete: PropTypes.func,
};

function InputVariables(props) {
    return (
        <OutputTab
            activeTab={props.activeTab}
            lookerTemplates={lookerParams.lookerPath.inputvariablesTab}
            onLoadComplete={props.onLoadComplete}
            tabLabel="InputVariables"
            includeChart
        />
    );
}

export default InputVariables;
